import {isPC, isTB} from '../consist/config'

export default () => {
  $('.x-clamp-title').shave(60, {spaces: false})
  $('.x-clamp-description').shave(60, {spaces: false})
  $('.x-clamp-breadcrumb').shave(25, {spaces: false})

  if (isPC || isTB) {
    $('.x-clamp-title-3').shave(120, {spaces: false})
  } else {
    $('.x-clamp-title-3').shave(72, {spaces: false})
  }
}